<script>
// import ApexCharts from 'apexcharts';
// import VueApexCharts from 'vue-apexcharts';
import { ref, onMounted } from 'vue';
import useFiliation from "@/filiation/composables/useFiliation";
import { format } from 'date-fns';
export default {
    setup() {
     const {
        countCrimeByRelationship,
        prisionNames
     } = useFiliation();
     const crimeByRelationshipList = ref([])
     let chartOptions = ref({
        chart: {
            type:'bar',
            height: 550,
              stacked: true,
              toolbar: {
                show: true
              },
        },
        xaxis: {
            categories: [],
            
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end', // 'around', 'end'
            borderRadiusWhenStacked: 'last',
            dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                      fontWeight: 900
                    }
                  }
                }
          },
        },
        dataLabels: {
         enabled: true,
         style: {
            fontSize: '12px',
            fontWeight: 500
         },
         formatter: function (val, opts) {
          const { seriesIndex, dataPointIndex } = opts;
          const parentesco = series.value[seriesIndex].name;
          const percentage = series.value[seriesIndex].percentageData[dataPointIndex];
         return `${parentesco}: ${val===1?`${val} caso`:`${val} casos`}  (${percentage}%)`;
        },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        yaxis: {
          title: {
            text: 'Cantidad',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
        y: {
          formatter: function (val, opts) {
            const { seriesIndex, dataPointIndex } = opts;
            const percentage = series.value[seriesIndex].percentageData[dataPointIndex];
            return ` ${val===1?`${val} caso`:`${val} casos`} (${percentage}%)`;
          },
        },
      },
        });
     let series = ref([]);
     const updateChart = async() => {
        const seriesData =  crimeByRelationshipList.value.series.map(serie => ({
          name: serie.name,
          data: serie.data.map(item => item.count),
          percentageData: serie.data.map(item => item.percentage),
        }));
        series.value = seriesData;
         chartOptions.value = {
          ...chartOptions.value,
          ...{
             xaxis: {
               categories: crimeByRelationshipList.value.categories,
          },
        },
      };
    };
     const getCrimeByRelationship = async () => {
      try {
        const { data } = await countCrimeByRelationship(formData.value);
        crimeByRelationshipList.value = data
        await updateChart()
      } catch (err) {
        console.error('Error al obtener los datos:', err);
      }
     };
     const formData = ref({
        departamento : 'NACIONAL',
        id_recinto_penitenciario:0
     })
     const prisionNamesList = ref([]);
     const listPrisionNames = async () => {
      const { data } = await prisionNames();
      formData.value.id_recinto_penitenciario=0;
      if (formData.value.departamento==='NACIONAL') {
         prisionNamesList.value=data.filter(recinto =>recinto.nombre_recinto_penitenciario!=='TODOS');
      }else{
        const resp = data.filter(recinto =>recinto.departamento===formData.value.departamento)
        prisionNamesList.value =resp;
      }
      await getCrimeByRelationship()
     }
     const getDataCrimeByRelationship = async () =>{
        console.log(formData.value);
     }
     onMounted(async() => {
    //   await getCrimeByRelationship();
      await listPrisionNames();
    });
        return{
            chartOptions,
            series,
            formData,
            prisionNamesList,
            listPrisionNames,
            getDataCrimeByRelationship,
            getCrimeByRelationship
        }
    },
}
</script>
<template>
<div class="card">
    <h4 class="card-title fw-bolder text-black text-center mt-10 mb-0">
      Relación de Parentesco por Delitos
    </h4>
   <div class="row">
    <div class="col-md-2 m-10">
    <label class="form-label required">Departamento:</label>
    <select
        class="form-select fuente"
        aria-label="select"
        v-model="formData.departamento"
        @change="listPrisionNames()"
        >
        <option value="NACIONAL">NACIONAL</option>
        <option value="BENI">BENI</option>
        <option value="CHUQUISACA">CHUQUISACA</option>
        <option value="COCHABAMBA">COCHABAMBA</option>
        <option value="LA PAZ">LA PAZ</option>
        <option value="ORURO">ORURO</option>
        <option value="PANDO">PANDO</option>
        <option value="POTOSÍ">POTOSÍ</option>
        <option value="SANTA CRUZ">SANTA CRUZ</option>
        <option value="TARIJA">TARIJA</option>
    </select> 
    </div>
    <div class="col-md-2 m-10">
    <label class="form-label required">Recinto Penitenciario:</label>
    <select
        v-model="formData.id_recinto_penitenciario"
        class="form-select fuente"
        aria-label="select"
        @change="getCrimeByRelationship()"
    >
        <option
        v-for="(list, key) in prisionNamesList"
        :value="list.id_recinto_penitenciario"
        :key="key"
        >
        {{ list.nombre_recinto_penitenciario }}
        </option>
        </select>
    </div>
   </div>
  <div>
    <apexchart type="bar" height="450" :options="chartOptions" :series="series"></apexchart>
  </div>
</div>    
</template>